export default {
    yAxis: [{
        title: {
            text: ''
        },
        categories: "",
        labels: {
            formatter: function () {
                var label = this.axis.defaultLabelFormatter.call(this);
                return label/1000000 + ' Mld.';
            },
            format: '{value}',
            style: {
                color: '#b0b6c3',
                fontSize: '15px'
            }
        },
        opposite: false
    }],
    series: [{
        name: function(){
                if(document.documentElement.lang == 'cz'){
                    return "Celková aktiva"
                }
                else{
                    return "Total assets"
                }
                
        }(),
        data: [225774, 292519, 583502, 743666, 1124763, 1575475, 2109388, 4982000, 9316100, 9371250, 8695660, 9265374, 10938751, 11932770],
        marker: {
            enabled: false
        },
    }],
}

//3495806,


// WEBPACK FOOTER //
// ./data/charts/aktiva.js